import { useSyncExternalStore } from 'react'
import { abonnerAdresse, adresseNotee } from './adresse-courante.js'

/**
 * L'ADRESSE AFFICHÉE, paramètres compris, pour un composant qui doit la
 * suivre sans attendre une navigation — la barre latérale, dont une fonction
 * peut désigner une VUE (`?vue=ecarts`) que l'écran change sur place.
 *
 * `chemin` est celui du routeur (`usePath`) : il sert tant que rien n'a été
 * noté. Ensuite l'adresse notée est toujours au moins aussi fraîche que lui —
 * le routeur la note à chaque navigation, avant de prévenir ses abonnés, et
 * les écrans à chaque réécriture (`remplacerRecherche`, étapes de
 * l'assistant de clôture).
 */
export function useAdresseCourante(chemin: string): string {
  return useSyncExternalStore(abonnerAdresse, adresseNotee) ?? chemin
}
